import './Footer.css';

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';

import { Button } from './ui/button';
import UserAgr from './footer/UserAgr';
import Pol from './footer/Pol';
import Prohibited from './footer/Prohibited';
import telegramIcon from '../assets/telegram-icon.svg';
import vkIcon from '../assets/vk-icon.svg';
import tgQr from '../assets/tg-qr.svg';
import footerDoc1 from '../assets/footer-doc1.docx';
import footerDoc2 from '../assets/footer-doc2.docx';
import footerDoc3 from '../assets/footer-doc3.docx';
import i18n from '../i18n';


export default function Footer() {
    const lang = (i18n.resolvedLanguage || i18n.language || 'ru').slice(0,2);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [modalDoc, setModalDoc] = useState(null);

    function handleAccountEnter() {
        window.open(`/login`, '_blank', 'noopener,noreferrer');
    }

    return(
        <footer>
            <div className='footer-blocks'>
                <div className='footer-block'>
                    <p>
                        {t('$Subheader10')}
                    </p>
                    <button className='footer-bttn' onClick={handleAccountEnter}>
                        {t('$Buttom4')}
                    </button>
                </div>
                <div className='footer-block'>
                    <Button 
                        variant="outline"
                        size="sm"
                        onClick={() => setModalDoc("useragr")}
                        style={{textDecoration: 'none', color: 'black', border: 'none', padding: '0', backgroundColor: 'inherit'}}
                    >
                        {t('$UserAgr')}
                    </Button>
                    <Button 
                        variant="outline"
                        size="sm"
                        onClick={() => setModalDoc("pol")}
                        style={{textDecoration: 'none', color: 'black', border: 'none', padding: '0', backgroundColor: 'inherit'}}
                    >
                        {t('$Pol')}
                    </Button>
                    <Button 
                        variant="outline"
                        size="sm"
                        onClick={() => setModalDoc("prohibited")}
                        style={{textDecoration: 'none', color: 'black', border: 'none', padding: '0', backgroundColor: 'inherit'}}
                    >
                        {t('$prohibited')}
                    </Button>
                </div>
                <div className='footer-block'>
                    <div>
                    <p className='footer-header'>
                        {t('Subheader36')}
                    </p>
                    <a href={`/registry`} className='gradient-text'>
                        {t('$register')}
                    </a>
                    <p className='footer-header'>
                        {t('UsefulBlockTitle3')}
                    </p>
                    <div className='flex flex-col items-center'>
                    <a href={`/courses`} className='gradient-text'>
                        {t('$FooterTitle')}
                    </a>
                    <a href={`/book`} className='gradient-text'>
                        Книга НИУ-ВШЭ
                    </a>
                    </div>
                    </div>
                </div>
                <div className='footer-block'>
                    <div>
                    <p className='footer-header'>
                        Для авторов
                    </p>
                    <a href={`/marketplace`} className='gradient-text'>
                        Маркетплейс для продажи документов
                    </a>
                    </div>
                </div>
                <div className='footer-block'>
                    <div style={{alignItems: 'center', textAlign: 'center', display: 'flex', flexDirection: 'column'}}>
                    <p className='footer-header'>
                        {t('$Contacts')}
                    </p>
                    <a href='https://t.me/Best_practices_online' target="_blank" rel="noopener noreferrer" >
                        <img src={tgQr} style={{width: '80px', height: '80px'}} alt='telegram-qr-code' />
                    </a>
                    <p>
                        info@best-practices.online
                    </p>
                    </div>
                </div>
            </div>
            {modalDoc && (
                <div
                    className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 w-full !mt-0"
                    onClick={() => setModalDoc(null)}   // клик по фону — закрыть
                    >
                    <div
                        className="bg-white rounded-lg shadow-lg w-full max-w-5xl mx-[20px] p-6 relative h-[80%] flex flex-col"
                        onClick={e => e.stopPropagation()} // чтобы клик внутри окна не закрывал
                    >
                        {/* крестик */}
                        <button
                        className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
                        onClick={() => setModalDoc(null)}
                        >
                        ✕
                        </button>
                        {modalDoc === 'useragr' && (
                            <div className='h-full prose prose-sm sm:prose-base max-w-none w-full overflow-auto mt-4 flex-1'>
                                <UserAgr lang={lang} />
                            </div>
                        )}
                        {modalDoc === 'pol' && (
                            <div className='h-full prose prose-sm sm:prose-base max-w-none w-full overflow-auto mt-4 flex-1'>
                                <Pol lang={lang} />
                            </div>
                        )}
                        {modalDoc === 'prohibited' && (
                            <div className='h-full prose prose-sm sm:prose-base max-w-none w-full overflow-auto mt-4 flex-1'>
                                <Prohibited lang={lang} />
                            </div>
                        )}
                    </div>
                </div>
            )}
        </footer>
    );
}